var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('answer-render',{ref:"answer",attrs:{"config":_vm.config[_vm.questionIndex]}},[_c('div',{attrs:{"slot":"head"},slot:"head"},[_c('answer-group-table',{attrs:{"config":_vm.config,"optionKey":"optionName","optionValueKey":"id","answerValidate":_vm.answerValidate,"questionIndex":_vm.questionIndex}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc447a04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/RadioBoxGroup/RadioBoxGroupAnswerPc.vue
// module id = null
// module chunks = 